import Navbar from "@/components/Navbar";
import SEO from "@/components/SEO";
import HeroSection from "@/components/HeroSection";
import CategoriesSection from "@/components/CategoriesSection";
import FeaturedListings from "@/components/FeaturedListings";
import HowItWorks from "@/components/HowItWorks";
import SwapEngineSection from "@/components/SwapEngineSection";
import AIAlgorithmAnimation from "@/components/AIAlgorithmAnimation";
import CTASection from "@/components/CTASection";
import BrokerValueSection from "@/components/BrokerValueSection";
import BrokerCTASection from "@/components/BrokerCTASection";
import Footer from "@/components/Footer";
import { useAudience } from "@/hooks/useAudience";

const Index = () => {
  const { audience } = useAudience();

  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Permuta Digital — Troque seu imóvel sem vender primeiro"
        description="Marketplace de permuta de imóveis no Brasil. Encontre pessoas que querem trocar e destrave negociações sem depender da venda prévia."
        path="/"
      />
      <Navbar />
      <HeroSection />
      {audience === "owner" ? (
        <>
          <CategoriesSection />
          <SwapEngineSection />
          <AIAlgorithmAnimation />
          <FeaturedListings />
          <HowItWorks />
          <CTASection />
        </>
      ) : (
        <>
          <SwapEngineSection />
          <AIAlgorithmAnimation />
          <BrokerValueSection />
          <HowItWorks />
          <BrokerCTASection />
        </>
      )}
      <Footer />
    </div>
  );
};

export default Index;
